export default {
	vipBenefits: {
		salaryTitle: 'Gaji VIP',
		benefitsTitle: 'Manfaat',
		yourVipProgress: 'Progres VIP Anda',
		progressToVip: '{percent}% menuju VIP {level}',
		vipMax: 'Level Maksimum Tercapai',
		vipLevelBenefits: 'Level & Manfaat VIP',
		betXpRule: 'Taruhan {amount} = {xp}EXP',
		btnReceive: 'Terima',
		btnJoinIn: 'Ikut Serta',
		btnReceived: 'Diterima',
		btnExpired: 'Kedaluwarsa',
		btnNotSettled: 'Belum Diselesaikan',
		btnComingSoon: 'Segera Hadir',
		btnViewMore: 'Lihat Selengkapnya',
		btnContactNow: 'Hubungi',
		guestTitleLevelup: 'Bonus Naik Level',
		guestTitleDaily: 'Gaji Harian',
		guestTitleWeekly: 'Gaji Mingguan',
		guestTitleMonthly: 'Gaji Bulanan',
		guestTitleCashback: 'Cashback',
		guestTitleRescue: 'Bonus Penyelamat',
		guestTitleEvents: 'Acara VIP',
		guestTitleSupport: 'Dukungan VIP',
		guestDescLevelup: 'Dapatkan bonus sekali setiap kali Anda mencapai level VIP baru.',
		guestDescDaily: 'Klaim hadiah gaji harian seiring naiknya level VIP Anda.',
		guestDescWeekly: 'Klaim hadiah gaji mingguan seiring naiknya level VIP Anda.',
		guestDescMonthly: 'Klaim hadiah gaji bulanan seiring naiknya level VIP Anda.',
		guestDescCashback: 'Dapatkan cashback dari pengeluaran permainan Anda.',
		guestDescRescue: 'Dapatkan bonus penyelamat untuk membantu Anda bangkit kembali.',
		guestDescEvents: 'Level VIP lebih tinggi membuka lebih banyak hadiah acara eksklusif.',
		guestDescSupport: 'Dukungan VIP khusus untuk bantuan lebih cepat.',
		comingSoonHint: 'Manfaat segera hadir, nantikan',
		receiveSuccess: 'Hadiah diterima',
		receiveFailed: 'Gagal menerima hadiah',
		typeUpgrade: 'Bonus Naik Level',
		typeDailySalary: 'Gaji Harian',
		typeWeeklySalary: 'Gaji Mingguan',
		typeMonthlySalary: 'Gaji Bulanan',
		typeRebate: 'Cashback',
		typeRescue: 'Bonus Penyelamat',
		typeVipActivity: 'Acara VIP',
		typeVipService: 'Dukungan VIP',
		tooltipRecharge: 'Isi ulang {current}/{target}',
		tooltipBets: 'Taruhan {current}/{target}',
		progressRecharge: 'Isi ulang',
		progressBets: 'Taruhan',
		descUpgradeBonus: 'Bonus Upgrade VIP{level} ×{count}',
		descDailySalary: 'Gaji Harian VIP{level} ×{count}',
		descWeeklySalary: 'Gaji Mingguan VIP{level} ×{count}',
		descMonthlySalary: 'Gaji Bulanan VIP{level} ×{count}',
		descUpgradeBonusPlain: 'Bonus Upgrade VIP{level}',
		descDailySalaryPlain: 'Gaji Harian VIP{level}',
		descWeeklySalaryPlain: 'Gaji Mingguan VIP{level}',
		descMonthlySalaryPlain: 'Gaji Bulanan VIP{level}',
		descRebate: 'Cashback Permainan VIP{level}',
		descRescue: 'Bonus Penyelamat VIP{level}',
		descVipActivity: 'Level VIP lebih tinggi membuka lebih banyak hadiah acara eksklusif.',
		descVipService: 'Dukungan VIP khusus untuk bantuan lebih cepat.',
		allBenefits: 'Semua Manfaat',
		vipClubTitle: 'VIP Club',
		more: 'Lainnya',
		moreDesc: 'Silakan lihat promosi kami untuk detail lebih lanjut.',
		promotions: 'Promosi',
		highlightsTitle: '8 Fitur Unggulan',
		highlightSupport: 'Dukungan VIP Eksklusif',
		highlightLevelup: 'Bonus Naik Level',
		highlightSalary: 'Gaji VIP',
		highlightRescue: 'Bonus Penyelamatan VIP',
		highlightGifts: 'Hadiah\nEksklusif VIP',
		highlightEvents: 'Acara VIP',
		highlightService: 'Layanan\nVIP Khusus',
		highlightWallet: 'Dompet\nKredit VIP',
		currentLevel: 'Level Saat Ini',
		keepPlayingReach: 'Terus bermain untuk mencapai',
		higherLevelRewards: 'Semakin tinggi level, semakin besar hadiahnya',
		levelUpUnlock: 'Naik level untuk membuka manfaat eksklusif dan nikmati pengalaman premium.',
		yourVipBenefits: 'Manfaat VIP Anda',
		viewVipLevels: 'Lihat Level VIP',
		exclusiveBenefitsTitle: 'Manfaat Eksklusif Anda',
		tipExclusiveRewards: 'Hadiah Eksklusif',
		tipHigherRakeback: 'Rakeback Lebih Tinggi',
		tipPrioritySupport: 'Dukungan Prioritas',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'Level',
		tableRequiredXp: 'EXP Dibutuhkan',
		tableLevelUpBonus: 'Bonus naik level',
		tableDailyRakeback: 'Rakeback harian',
		tableWeeklyLossback: 'Cashback kekalahan mingguan',
		signIn: 'Masuk',
		vipClubDefaultDesc: 'Gabung VIP Club kami sekarang dan bersiaplah dihujani hadiah, giveaway, dan fitur menarik.',
	},
};
